(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const breakPoint = 640;
  const toggleSpFooterNav = function() {
    this.classList.toggle("toggle-open");
    this.nextElementSibling.classList.toggle("sp-visible");
  }
  window.addEventListener(
    "load",
    () => {
      const toggleFooterNavTrigger = document.querySelectorAll(".js-sp-footer-nav-toggle");
      if (breakPoint > screen.width) {
        toggleFooterNavTrigger.forEach((trigger) => {
          trigger.addEventListener('click', toggleSpFooterNav);
        })
      }
    },
    false
  );
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-about"]) return;
  try {
    
window.addEventListener(
  "load",
  () => {
    AOS.init();
    console.log("loaded");
  },
  false
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-yamachi"]) return;
  try {
    
  window.addEventListener(
    "load",
    () => {
      AOS.init();
      console.log("load");
    },
    false
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('.js-product-toggle-item').forEach(element => {
  const toggle = element.querySelector('.js-product-toggle-item-trigger');
  const target = element.querySelector('.js-product-toggle-item-content');
  toggle.addEventListener("click", function(){
    this.classList.toggle('active');
    target.classList.toggle('active');
  }, false);
})


const breakPoint = 640;
let swiper;
let swiperBool;

window.addEventListener(
  "load",
  () => {
    if (breakPoint < screen.width) {
      swiperBool = false;
    } else {
      createSwiper();
      swiperBool = true;
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    if (breakPoint < screen.width && swiperBool) {
      swiper.destroy(false, true);
      swiperBool = false;
    } else if (breakPoint >= screen.width && !swiperBool) {
      createSwiper();
      swiperBool = true;
    }
  },
  false
);

const createSwiper = () => {
  swiper = new Swiper(".js-product-thumb-swiper-container", {
    loop: true,
  });
};


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-visual"] && !Shopify.designMode) return;
  try {
    
const heroSwiper = new Swiper('.js-hero-swiper-container', {
  effect: "fade",
  initialSlide: Math.floor(Math.random() * document.querySelectorAll('.js-hero-swiper-container .swiper-slide').length),
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".js-hero-swiper-pagination",
    clickable: true,
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-caroucels-type1"]) return;
  try {
    
const swiper = new Swiper('.js-ranking-swiper-container', {
  // Optional parameters
  centerdSlides: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
const recentCheckSwiper = new Swiper('.js-recent-check-swiper-container', {
  // Optional parameters
  centerdSlides: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-caroucels-type2"]) return;
  try {
    
const reccomendSwiper = new Swiper('.js-recommend-swiper-container', {
  // Optional parameters
  centerdSlides: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
const recentCheckSwiper = new Swiper('.js-recent-check-swiper-container', {
  // Optional parameters
  centerdSlides: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-product-rankings"]) return;
  try {
    
const swiper = new Swiper('.js-ranking-swiper-container', {
  // Optional parameters
  centerdSlides: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const recipeAwiper = new Swiper('.js-recipe-swiper-container', {
  // Optional parameters
  centerdSlides: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-slideshow"]) return;
  try {
    
(function() {
  var el = document.querySelector('.hero-swiper-random');
  if (!el) return;

  new Swiper('.hero-swiper-random', {
    effect: "fade",
    autoplay: { delay: 5000 },
    pagination: {
      el: ".hero-swiper-random-pagination",
      clickable: true,
    },
  });

  el.style.visibility = 'visible';
})();

  } catch(e) { console.error(e); }
})();
})();
